import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex w-full gap-10 py-3 sm:py-15 xl:gap-30',
    stickyHeader:
      'pointer-events-none invisible fixed inset-x-0 top-0 z-30 opacity-0 transition-opacity duration-150',
    container: 'flex w-full flex-col gap-4 sm:gap-12',
    header: 'flex flex-col gap-6',
    content: 'flex w-full flex-col gap-10 md:flex-row md:gap-12',
    main: 'w-full md:flex-1',
    sidebar: 'shrink-0 pt-10 max-lg:hidden',
    sidebarSticky: 'sticky top-30',
    sidebarMobile: 'lg:hidden'
  }
});
